<!-- eslint-disable @angular-eslint/template/i18n -->
@if (appStatus() !== 'ERROR' && appStatus() !== 'LOADING') {
  <router-outlet></router-outlet>
}

@if (appStatus() === 'LOADING' || checkingGuard || loadingTransloco) {
  <div class="overlay">
    <cwo-loader></cwo-loader>
  </div>
}

@if (appStatus() === 'ERROR') {
  <div style="display: flex; align-items: center; flex-direction: column; padding: 3rem; z-index: 10000;">
    <h1>Error Loading Content</h1>
    <button (click)="reload()" class="button-accent">Reload Page</button>
  </div>
}

<cwo-toast></cwo-toast>
